// @flow

import {
  FETCH_FAQ_CATEGORIES,
  FETCH_FAQ_CATEGORIES_SUCCESS,
  FETCH_FAQ_CATEGORIES_FAILURE,
  FETCH_FAQ_CATEGORY_QUESTIONS,
  FETCH_FAQ_CATEGORY_QUESTIONS_SUCCESS,
  FETCH_FAQ_CATEGORY_QUESTIONS_FAILURE
} from './constants';

import type { Action, FaqCategory, FaqQuestion } from '../types';

export const fetchFaqCategories = (): Action => ({
  type: FETCH_FAQ_CATEGORIES
});

export const fetchFaqCategoriesSuccess = (data: Array<FaqCategory>): Action => ({
  type: FETCH_FAQ_CATEGORIES_SUCCESS,
  data
});

export const fetchFaqCategoriesFailure = (error: Error): Action => ({
  type: FETCH_FAQ_CATEGORIES_FAILURE,
  error
});

export const fetchFaqCategoryQuestions = (categorySlug: string, limit: number): Action => ({
  type: FETCH_FAQ_CATEGORY_QUESTIONS,
  categorySlug,
  limit
});

export const fetchFaqCategoryQuestionsSuccess = (categorySlug: string) => (
  data: Array<FaqQuestion>
): Action => ({
  type: FETCH_FAQ_CATEGORY_QUESTIONS_SUCCESS,
  data,
  categorySlug
});

export const fetchFaqCategoryQuestionsFailure = (categorySlug: string) => (
  error: Error
): Action => ({
  type: FETCH_FAQ_CATEGORY_QUESTIONS_FAILURE,
  error,
  categorySlug
});
